
import { defineComponent, ref, watchEffect } from "vue";

import { useElementHeight } from "@/composables/useElementHeight";
import FirstRow from "@/components/header/desktop-header/FirstRow.vue";
import SecondRow from "@/components/header/desktop-header/SecondRow.vue";
import ThirdRow from "@/components/header/desktop-header/ThirdRow.vue";

export default defineComponent({
  components: {
    FirstRow,
    SecondRow,
    ThirdRow,
  },
  setup(props, context) {
    const header = ref<HTMLElement | null>(null);
    const headerHeight = useElementHeight(header);
    watchEffect(() => {
      context.emit("update:headerHeight", headerHeight.value);
    });

    return {
      header,
    };
  },
});
